<template>
  <!-- 预约区域 -->
  <div class="boking-box" v-if="showBoking">
    <!-- 时间 -->
    <div class="bk-time">
      <n-countdown
        :render="({ hours, minutes, seconds }) => formotTime(hours, minutes, seconds)"
        :duration="millisecond">
      </n-countdown>
    </div>
    <!-- 未预约 按钮 -->
    <div class="bk-alk bk-not" v-if="!notOrRdy" @click="togBokState" >
      <img src="/src/assets/live/sub.svg" style="width: 18px; height: 18px; margin-right: 2px;">
      <span class="n-sp">Subscribe</span>
    </div>
    <!-- 已预约 按钮 -->
    <div class="bk-alk bk-redy" v-else @click="togBokState">Cancel</div>
  </div>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import { isDev, typeViteEnv } from '@/utils/env'
import { formotTime } from './formot'

const contentId = document.querySelector('body').getAttribute('data-id')
const time = document.querySelector('body')?.getAttribute('data-publish-time') || 0

// 直播预约
const showBoking = ref<Boolean>(true)    // 直播预约 显隐
const notOrRdy = ref<Boolean>(false)     //  未预约 已预约 按钮显隐
const togBokState = () => {   //  切换
  openApp()
}

const openApp = () => {
  window.open(`${isDev() ? typeViteEnv('VITE_BASE_HOMEPAGE_URL') : location.origin}/publicity?contentType=live&contentId=${contentId}`)
}

const millisecond = ref(0)

onMounted(() => {
  if (time) {
    millisecond.value = dayjs(Number(time)).diff(dayjs(), 'millisecond') > 0 ? dayjs(Number(time)).diff(dayjs(), 'millisecond') : 0
  }
})
</script>

<style lang="less" scoped>
.boking-box {
  width: 380px;
  height: 142px;
  background: #2C2F44;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px 0;
  box-sizing: border-box;
  
  .bk-time {
    width: 280px;
    height: 64px;
    // background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    
    &:deep(.t-num) {
      display: inline-block;
      width: 56px;
      height: 64px;
      text-align: center;
      line-height: 64px;
      background: #1A1E35;
      box-shadow: inset 0px 0px 24px 0px rgba(0, 0, 0, 0.16);
      border-radius: 0px 0px 0px 0px;
      font-size: 28px;
      font-family: Droid Serif-Bold, Droid Serif;
      font-weight: 700;
      color: #FFFFFF;
    }
    
    &:deep(.t-ut) {
      margin-left: 16px;
      // margin: 0 16px 0 17px;
      font-size: 16px;
      font-family: Droid Serif-Regular, Droid Serif;
      font-weight: 400;
      color: #FFFFFF;
    }
    
    &:deep(.ut-m-r) {
      margin-right: 16px;
    }
    
  }
  
  .bk-alk {
    width: 300px;
    height: 42px;
    border-radius: 1px 1px 1px 1px;
    cursor: pointer;
  }
  
  .bk-not {
    background-color: #F22B41;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .n-sp {
      font-size: 14px;
      font-family: Droid Serif-Bold, Droid Serif;
      font-weight: 700;
      color: #FFFFFF;
    }
  }
  
  .bk-redy {
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    font-family: Droid Serif-Bold, Droid Serif;
    font-weight: 700;
    color: #FFFFFF;
    background: #A3A3A3;
  }
  
}
</style>
